import { routesPath } from '@router/routes';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { generatePath } from 'react-router';
import React from 'react';
import { SupportSubjectDetailView } from './SupportSubjectDetailView';
import SupportSubjectDetailHeader from './SupportSubjectDetailHeader';

export const SupportSubjectDetail = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { id, patientId } = useParams<{ id: string; patientId: string }>();
  const subject = state?.subject;
  const goBack = () => {
    if (!id || !patientId) return;
    const url = generatePath(routesPath.clinicalTrialSubjectList, { id });
    navigate(url);
  };

  return (
    <div>
      <SupportSubjectDetailHeader onBack={goBack} subject={subject} />

      <div className='flex w-full items-center justify-between border-b' />

      <div className='w-full px-4 mt-4'>
        <div className='mx-auto w-full max-w-[90%]'>
          <SupportSubjectDetailView subject={subject} />
        </div>
      </div>
    </div>
  );
};
